import React from 'react';
import { useDocumentTitle } from '../_hooks/useDocumentTitle';
import { useRISAQuery } from './api/useRISAQuery';
import { Link } from '../CommonComponents/OPL/Link/Link';
import { Loading } from '../CommonComponents/OPL/Loading/Loading';
import { Box } from '../CommonComponents/OPL/Box/Box';
import { ErrorState } from '../CommonComponents/OPL/AsyncStates/ErrorState/ErrorState';
import RISALogoSVG from '../../img/RISA-logo.svg';

interface Props {
  clientId: string;
}

export const RISA: React.FC<Props> = ({ clientId }) => {
  useDocumentTitle('RISA');

  const { data, isLoading, isError, refetch } = useRISAQuery(clientId);

  if (isLoading) {
    return (
      <Box alignItems="center" display="flex" height="100%" justifyContent="center" width="100%">
        <Loading text="Loading..." />
      </Box>
    );
  }

  if (isError) {
    return (
      <Box alignItems="center" display="flex" height="100%" justifyContent="center" width="100%">
        <ErrorState onAction={refetch} />
      </Box>
    );
  }

  if (!data) {
    return null;
  }

  return (
    <Box
      display="flex"
      width="100%"
      height="100%"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
    >
      <Box width={400}>
        <RISALogoSVG width="100%" height="100%" viewBox="0 0 365 156" />
      </Box>
      <Link variant="button" href={data.risaRedirectUrl}>
        Launch RISA Questionnaire
      </Link>
    </Box>
  );
};
